<script>
    import { navigate, useLocation } from 'svelte-navigator'
    import { ChevronFordware } from '../Icons'
    const location = useLocation()
    export let options = []
    export let limit = -1
    function safelength(val) {
        return ['string', 'object'].includes(typeof val)
            ? val.length
            : String(val).length
    }
    $: if (options) {
        limit = options
            .sort((a, b) => (safelength(a.path) >= safelength(b.path) ? 1 : -1))
            .findIndex((o) => o.path === $location.pathname)
    }
    $: filtered = limit !== -1 ? options.slice(0, limit + 1) : options
</script>

<div>
    {#each filtered as { label, path }, i}
        {#if i !== 0}
            <ChevronFordware size={16} color="var(--color-grey-800)" />
        {/if}
        <p
            class:selected={i !== filtered.length - 1}
            on:click={(_) => navigate(path)}
        >
            {label}
        </p>
    {/each}
</div>

<style>
    div {
        position: relative;
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        padding: 0px 68px;
        gap: 22px;
    }
    .selected {
        color: var(--color-grey-800);
        cursor: pointer;
    }
</style>
